import angular from 'angular';

export default angular.module('cms.creator.html.trusted.filter', [])
    .filter('trust', ['$sce', function HtmlTrusted($sce) {

        return function (htmlCode) {
            return new $sce.trustAsHtml(htmlCode);
        };
    }]).name;





// WEBPACK FOOTER //
// ./src/cmsCore/HtmlTrustedFilter/HtmlTrustedFilter.js